function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { combineTransactionSteps, getChangedRanges, getMarksBetween, findChildrenInRange, getAttributes, Mark, mergeAttributes, markPasteRule } from '@tiptap/core';
import { test, find as _find } from 'linkifyjs';
import { Plugin, PluginKey } from 'prosemirror-state';
function autolink(options) {
  return new Plugin({
    key: new PluginKey('autolink'),
    appendTransaction: function appendTransaction(transactions, oldState, newState) {
      var docChanges = transactions.some(function (transaction) {
        return transaction.docChanged;
      }) && !oldState.doc.eq(newState.doc);
      var preventAutolink = transactions.some(function (transaction) {
        return transaction.getMeta('preventAutolink');
      });
      if (!docChanges || preventAutolink) {
        return;
      }
      var tr = newState.tr;
      var transform = combineTransactionSteps(oldState.doc, transactions);
      var mapping = transform.mapping;
      var changes = getChangedRanges(transform);
      changes.forEach(function (_ref) {
        var oldRange = _ref.oldRange,
          newRange = _ref.newRange;
        // at first we check if we have to remove links
        getMarksBetween(oldRange.from, oldRange.to, oldState.doc).filter(function (item) {
          return item.mark.type === options.type;
        }).forEach(function (oldMark) {
          var newFrom = mapping.map(oldMark.from);
          var newTo = mapping.map(oldMark.to);
          var newMarks = getMarksBetween(newFrom, newTo, newState.doc).filter(function (item) {
            return item.mark.type === options.type;
          });
          if (!newMarks.length) {
            return;
          }
          var newMark = newMarks[0];
          var oldLinkText = oldState.doc.textBetween(oldMark.from, oldMark.to, undefined, ' ');
          var newLinkText = newState.doc.textBetween(newMark.from, newMark.to, undefined, ' ');
          var wasLink = test(oldLinkText);
          var isLink = test(newLinkText);
          // remove only the link, if it was a link before too
          // because we don’t want to remove links that were set manually
          if (wasLink && !isLink) {
            tr.removeMark(newMark.from, newMark.to, options.type);
          }
        });
        // now let’s see if we can add new links
        findChildrenInRange(newState.doc, newRange, function (node) {
          return node.isTextblock;
        }).forEach(function (textBlock) {
          // we need to define a placeholder for leaf nodes
          // so that the link position can be calculated correctly
          var text = newState.doc.textBetween(textBlock.pos, textBlock.pos + textBlock.node.nodeSize, undefined, ' ');
          _find(text).filter(function (link) {
            return link.isLink;
          })
          // calculate link position
          .map(function (link) {
            return _objectSpread(_objectSpread({}, link), {}, {
              from: textBlock.pos + link.start + 1,
              to: textBlock.pos + link.end + 1
            });
          })
          // check if link is within the changed range
          .filter(function (link) {
            var fromIsInRange = newRange.from >= link.from && newRange.from <= link.to;
            var toIsInRange = newRange.to >= link.from && newRange.to <= link.to;
            return fromIsInRange || toIsInRange;
          })
          // add link mark
          .forEach(function (link) {
            tr.addMark(link.from, link.to, options.type.create({
              href: link.href
            }));
          });
        });
      });
      if (!tr.steps.length) {
        return;
      }
      return tr;
    }
  });
}
function clickHandler(options) {
  return new Plugin({
    key: new PluginKey('handleClickLink'),
    props: {
      handleClick: function handleClick(view, pos, event) {
        var _a;
        var attrs = getAttributes(view.state, options.type.name);
        var link = (_a = event.target) === null || _a === void 0 ? void 0 : _a.closest('a');
        if (link && attrs.href) {
          window.open(attrs.href, attrs.target);
          return true;
        }
        return false;
      }
    }
  });
}
function pasteHandler(options) {
  return new Plugin({
    key: new PluginKey('handlePasteLink'),
    props: {
      handlePaste: function handlePaste(view, event, slice) {
        var state = view.state;
        var selection = state.selection;
        var empty = selection.empty;
        if (empty) {
          return false;
        }
        var textContent = '';
        slice.content.forEach(function (node) {
          textContent += node.textContent;
        });
        var link = _find(textContent).find(function (item) {
          return item.isLink && item.value === textContent;
        });
        if (!textContent || !link) {
          return false;
        }
        options.editor.commands.setMark(options.type, {
          href: link.href
        });
        return true;
      }
    }
  });
}
var Link = Mark.create({
  name: 'link',
  priority: 1000,
  keepOnSplit: false,
  inclusive: function inclusive() {
    return this.options.autolink;
  },
  addOptions: function addOptions() {
    return {
      openOnClick: true,
      linkOnPaste: true,
      autolink: true,
      HTMLAttributes: {
        target: '_blank',
        rel: 'noopener noreferrer nofollow'
      }
    };
  },
  addAttributes: function addAttributes() {
    return {
      href: {
        default: null
      },
      target: {
        default: this.options.HTMLAttributes.target
      }
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'a[href]'
    }];
  },
  renderHTML: function renderHTML(_ref2) {
    var HTMLAttributes = _ref2.HTMLAttributes;
    return ['a', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;
    return {
      setLink: function setLink(attributes) {
        return function (_ref3) {
          var chain = _ref3.chain;
          return chain().setMark(_this.name, attributes).setMeta('preventAutolink', true).run();
        };
      },
      toggleLink: function toggleLink(attributes) {
        return function (_ref4) {
          var chain = _ref4.chain;
          return chain().toggleMark(_this.name, attributes, {
            extendEmptyMarkRange: true
          }).setMeta('preventAutolink', true).run();
        };
      },
      unsetLink: function unsetLink() {
        return function (_ref5) {
          var chain = _ref5.chain;
          return chain().unsetMark(_this.name, {
            extendEmptyMarkRange: true
          }).setMeta('preventAutolink', true).run();
        };
      }
    };
  },
  addPasteRules: function addPasteRules() {
    return [markPasteRule({
      find: function find(text) {
        return _find(text).filter(function (link) {
          return link.isLink;
        }).map(function (link) {
          return {
            text: link.value,
            index: link.start,
            data: link
          };
        });
      },
      type: this.type,
      getAttributes: function getAttributes(match) {
        var _a;
        return {
          href: (_a = match.data) === null || _a === void 0 ? void 0 : _a.href
        };
      }
    })];
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var plugins = [];
    if (this.options.autolink) {
      plugins.push(autolink({
        type: this.type
      }));
    }
    if (this.options.openOnClick) {
      plugins.push(clickHandler({
        type: this.type
      }));
    }
    if (this.options.linkOnPaste) {
      plugins.push(pasteHandler({
        editor: this.editor,
        type: this.type
      }));
    }
    return plugins;
  }
});
export { Link, Link as default };